
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Donts, Dos, Preview } from "@lighting-beetle/lighter-styleguide";
import { Grid, GridCol } from "./../../../components";
import ProductCard from "./ProductCard";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Product card`}</h1>
    <p>{`This is description and purpose of this pattern.`}</p>
    <Grid mdxType="Grid">
  <GridCol size={{
        m: 6
      }} mdxType="GridCol">
    <Dos mdxType="Dos">
      <ul>
        <li>List of do&apos;s</li>
      </ul>
    </Dos>
  </GridCol>
  <GridCol size={{
        m: 6
      }} mdxType="GridCol">
    <Donts mdxType="Donts">
      <ul>
        <li>List of dont&apos;s</li>
      </ul>
    </Donts>
  </GridCol>
    </Grid>
    <h2>{`Example`}</h2>
    <Preview code={<ProductCard imageSrc="https://plantizia.com/wp-content/uploads/2018/03/IMG_20180209_142624-760x400.jpg" mdxType="ProductCard">
      <h3>Riasogule</h3>
      <p>
        Riasogule sú sladkovodné rastliny, pôvodom z Japonska. Sú označované za
        najmenej náročnú rastlinku na svete. Stačí ich mať v studenej vode a
        prežijú s vami mnoho rokov bez toho, aby ste sa o ne museli starať ako o
        bežné rastlinky.
      </p>
    </ProductCard>} mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          m: 6,
          l: 4
        }} mdxType="GridCol">
      <ProductCard imageSrc="https://plantizia.com/wp-content/uploads/2018/03/IMG_20180209_142624-760x400.jpg" mdxType="ProductCard">
        <h3>Riasogule</h3>
        <p>
          Riasogule sú sladkovodné rastliny, pôvodom z Japonska. Sú označované
          za najmenej náročnú rastlinku na svete. Stačí ich mať v studenej vode
          a prežijú s vami mnoho rokov bez toho, aby ste sa o ne museli starať
          ako o bežné rastlinky.
        </p>
      </ProductCard>
    </GridCol>
  </Grid>
    </Preview>
    <h2>{`Variants`}</h2>
    <h2>{`Accessibility`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;